// 边类型配置 - 定义不同节点类型组合允许的边类型
export interface EdgeTypeRule {
  sourceNodeType: string | string[]; // 源节点类型，支持数组表示多种类型
  targetNodeType: string | string[]; // 目标节点类型，支持数组表示多种类型
  allowedEdgeTypes: string[]; // 允许的边类型ID列表
  description?: string; // 规则描述
}

// 边类型过滤配置
export const edgeTypeRules: EdgeTypeRule[] = [
  // 对象到对象的关联
  {
    sourceNodeType: 'rect',
    targetNodeType: 'rect',
    allowedEdgeTypes: [
      'middle-arrow',
      'middle-arrow-double-triangle',
      'middle-arrow-hollow-triangle',
      'middle-arrow-triangle-circle',
      'polyline',
      'bidirectional-arrow',
    ],
    description: '对象到对象',
  },

  // 对象到过程的关联
  {
    sourceNodeType: 'rect',
    targetNodeType: 'polygon',
    allowedEdgeTypes: [
      'middle-arrow-double-triangle',
      'middle-arrow-triangle-circle',
      'polyline',
      'bidirectional-arrow',
    ],
    description: '对象到过程',
  },

  // 过程到对象的关联
  {
    sourceNodeType: 'polygon',
    targetNodeType: 'rect',
    allowedEdgeTypes: [
      'middle-arrow-double-triangle',
      'polyline',
      'bidirectional-arrow',
    ],
    description: '过程到对象',
  },

  // 过程到过程的关联
  {
    sourceNodeType: 'polygon',
    targetNodeType: 'polygon',
    allowedEdgeTypes: [
      'middle-arrow',
      'middle-arrow-double-triangle',
      'middle-arrow-hollow-triangle',
      'middle-arrow-triangle-circle',
      'polyline',
      'bidirectional-arrow',
    ],
    description: '过程到过程',
  },

  // 对象到状态的关联
  {
    sourceNodeType: 'rect',
    targetNodeType: 'state',
    allowedEdgeTypes: [
      'middle-arrow',
      'middle-arrow-double-triangle',
      'polyline',
      'bidirectional-arrow',
    ],
    description: '对象到状态',
  },

  // 状态到对象的关联
  {
    sourceNodeType: 'state',
    targetNodeType: 'rect',
    allowedEdgeTypes: [
      'middle-arrow',
      'middle-arrow-double-triangle',
      'middle-arrow-hollow-triangle',
      'polyline',
      'bidirectional-arrow',
    ],
    description: '状态到对象',
  },

  // 过程到状态的关联
  {
    sourceNodeType: 'polygon',
    targetNodeType: 'state',
    allowedEdgeTypes: [
      'middle-arrow-double-triangle',
      'polyline',
      'bidirectional-arrow',
    ],
    description: '过程到状态',
  },

  // 状态到过程的关联
  {
    sourceNodeType: 'state',
    targetNodeType: 'polygon',
    allowedEdgeTypes: [
      'middle-arrow-double-triangle',
      'polyline',
      'bidirectional-arrow',
    ],
    description: '状态到过程',
  },

  // 状态到状态的关联
  {
    sourceNodeType: 'state',
    targetNodeType: 'state',
    allowedEdgeTypes: [
      'middle-arrow-double-triangle',
      'polyline',
      'bidirectional-arrow',
    ],
    description: '状态到状态：支持单向关联、对等关联、泛化关系',
  },

  // 值节点相关的关联（与状态节点规则类似）
  // 对象到值的关联
  {
    sourceNodeType: 'rect',
    targetNodeType: 'value',
    allowedEdgeTypes: [
      'middle-arrow',
      'middle-arrow-double-triangle',
      'polyline',
      'bidirectional-arrow',
    ],
    description: '对象到值',
  },

  // 值到对象的关联
  {
    sourceNodeType: 'value',
    targetNodeType: 'rect',
    allowedEdgeTypes: [
      'middle-arrow',
      'middle-arrow-double-triangle',
      'middle-arrow-hollow-triangle',
      'polyline',
      'bidirectional-arrow',
    ],
    description: '值到对象',
  },

  // 过程到值的关联
  {
    sourceNodeType: 'polygon',
    targetNodeType: 'value',
    allowedEdgeTypes: [
      'middle-arrow-double-triangle',
      'polyline',
      'bidirectional-arrow',
    ],
    description: '过程到值',
  },

  // 值到过程的关联
  {
    sourceNodeType: 'value',
    targetNodeType: 'polygon',
    allowedEdgeTypes: [
      'middle-arrow-double-triangle',
      'polyline',
      'bidirectional-arrow',
    ],
    description: '值到过程',
  },

  // 值到值的关联
  {
    sourceNodeType: 'value',
    targetNodeType: 'value',
    allowedEdgeTypes: [
      'middle-arrow-double-triangle',
      'polyline',
      'bidirectional-arrow',
    ],
    description: '值到值：支持单向关联、对等关联、泛化关系',
  },

  // 状态到值的关联
  {
    sourceNodeType: 'state',
    targetNodeType: 'value',
    allowedEdgeTypes: [
      'middle-arrow-double-triangle',
      'polyline',
      'bidirectional-arrow',
    ],
    description: '状态到值',
  },

  // 值到状态的关联
  {
    sourceNodeType: 'value',
    targetNodeType: 'state',
    allowedEdgeTypes: [
      'middle-arrow-double-triangle',
      'polyline',
      'bidirectional-arrow',
    ],
    description: '值到状态',
  },

  // 圆形节点（属性）相关的关联
  {
    sourceNodeType: 'circle',
    targetNodeType: ['rect', 'polygon', 'state', 'value'],
    allowedEdgeTypes: ['polyline'],
    description: '属性到其他节点：仅支持单向关联',
  },

  {
    sourceNodeType: ['rect', 'polygon', 'state', 'value'],
    targetNodeType: 'circle',
    allowedEdgeTypes: ['polyline'],
    description: '其他节点到属性：仅支持单向关联',
  },

  // 菱形节点相关的关联
  {
    sourceNodeType: 'diamond',
    targetNodeType: ['rect', 'polygon', 'state', 'circle', 'value'],
    allowedEdgeTypes: ['polyline', 'middle-arrow'],
    description: '菱形到其他节点：支持单向关联、聚合关系',
  },

  {
    sourceNodeType: ['rect', 'polygon', 'state', 'circle', 'value'],
    targetNodeType: 'diamond',
    allowedEdgeTypes: ['polyline', 'middle-arrow'],
    description: '其他节点到菱形：支持单向关联、聚合关系',
  },

  // 分组节点（dynamic-group）相关的关联
  // 对象到分组
  {
    sourceNodeType: 'rect',
    targetNodeType: 'dynamic-group',
    allowedEdgeTypes: [
      'middle-arrow',
      'middle-arrow-double-triangle',
      'middle-arrow-hollow-triangle',
      'middle-arrow-triangle-circle',
      'polyline',
      'bidirectional-arrow',
    ],
    description: '对象到分组：与对象到对象相同',
  },

  // 分组到对象
  {
    sourceNodeType: 'dynamic-group',
    targetNodeType: 'rect',
    allowedEdgeTypes: [
      'middle-arrow',
      'middle-arrow-double-triangle',
      'middle-arrow-hollow-triangle',
      'middle-arrow-triangle-circle',
      'polyline',
      'bidirectional-arrow',
    ],
    description: '分组到对象：与对象到对象相同',
  },

  // 分组到分组
  {
    sourceNodeType: 'dynamic-group',
    targetNodeType: 'dynamic-group',
    allowedEdgeTypes: [
      'middle-arrow',
      'middle-arrow-double-triangle',
      'middle-arrow-hollow-triangle',
      'middle-arrow-triangle-circle',
      'polyline',
      'bidirectional-arrow',
    ],
    description: '分组到分组：与对象到对象相同',
  },

  // 过程到分组
  {
    sourceNodeType: 'polygon',
    targetNodeType: 'dynamic-group',
    allowedEdgeTypes: [
      'middle-arrow-double-triangle',
      'polyline',
      'bidirectional-arrow',
    ],
    description: '过程到分组',
  },

  // 分组到过程
  {
    sourceNodeType: 'dynamic-group',
    targetNodeType: 'polygon',
    allowedEdgeTypes: [
      'middle-arrow-double-triangle',
      'middle-arrow-triangle-circle',
      'polyline',
      'bidirectional-arrow',
    ],
    description: '分组到过程',
  },
];

// 默认允许的边类型（当没有匹配的规则时）
export const defaultAllowedEdgeTypes: string[] = [
  'polyline',
  'bidirectional-arrow',
];

/**
 * 根据源节点和目标节点类型获取允许的边类型
 * @param sourceNodeType 源节点类型
 * @param targetNodeType 目标节点类型
 * @returns 允许的边类型ID数组
 */
export function getAllowedEdgeTypes(
  sourceNodeType: string,
  targetNodeType: string
): string[] {
  // 查找匹配的规则
  const matchingRule = edgeTypeRules.find(rule => {
    const sourceMatch = Array.isArray(rule.sourceNodeType)
      ? rule.sourceNodeType.includes(sourceNodeType)
      : rule.sourceNodeType === sourceNodeType;

    const targetMatch = Array.isArray(rule.targetNodeType)
      ? rule.targetNodeType.includes(targetNodeType)
      : rule.targetNodeType === targetNodeType;

    return sourceMatch && targetMatch;
  });

  // 返回匹配规则的允许类型，如果没有匹配的规则则返回默认类型
  return matchingRule ? matchingRule.allowedEdgeTypes : defaultAllowedEdgeTypes;
}

/**
 * 检查指定的边类型是否被允许
 * @param sourceNodeType 源节点类型
 * @param targetNodeType 目标节点类型
 * @param edgeType 边类型
 * @returns 是否被允许
 */
export function isEdgeTypeAllowed(
  sourceNodeType: string,
  targetNodeType: string,
  edgeType: string
): boolean {
  const allowedTypes = getAllowedEdgeTypes(sourceNodeType, targetNodeType);
  return allowedTypes.includes(edgeType);
}
